<template>
<svg class="custom-icon" width="44" height="35" viewBox="0 0 44 35" xmlns="http://www.w3.org/2000/svg">
        <!-- <rect width="44" height="35"/> -->
        <rect x="7" y="1" width="30" height="25" rx="3" />
        <path d="M38 6C38 4.34315 39.3431 3 41 3H42C42.5523 3 43 3.44772 43 4V23.5C43 24.8807 41.8807 26 40.5 26V26C39.1193 26 38 24.8807 38 23.5V6Z" />
        <path d="M1 4C1 3.44772 1.44772 3 2 3H3C4.65685 3 6 4.34315 6 6V23.5C6 24.8807 4.88071 26 3.5 26V26C2.11929 26 1 24.8807 1 23.5V4Z" />
        <rect x="41" y="27" width="7" height="38" rx="3.5" transform="rotate(90 41 27)" />
    </svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
